import {
  FETCH_FRANCHISE_LISTINGS,
  FETCH_ADMIN_FRANCHISE_LISTINGS,
  FETCH_FRANCHISE_LISTINGS_STARTED,
  FETCH_FRANCHISE_DETAILS,
  EDITFRANCHISE,
  SELECT_PLAN,
  RESETFORMS,
} from './types';
import franchiseService from '../../common/services/franchiseService';

export const fetchFranchiseListings = (pageNumber = 1) => dispatch => {
  franchiseService.getFranchises(pageNumber).then(
    res => {
      dispatch({
        type: FETCH_FRANCHISE_LISTINGS,
        payload: res.data,
      });
    },
    err => {
      dispatch({
        type: FETCH_FRANCHISE_LISTINGS,
        payload: { data: [] },
      });
    },
  );
};

export const fetchFranchiseDetails = id => dispatch => {
  franchiseService.getFranchise(id).then(
    res => {
      dispatch({
        type: FETCH_FRANCHISE_DETAILS,
        payload: res.data,
      });
    },
    err => {
      dispatch({
        type: FETCH_FRANCHISE_DETAILS,
        payload: {},
      });
    },
  );
};

export const editFranchise = id => dispatch => {
  franchiseService.getFranchise(id, true).then(
    res => {
      dispatch({
        type: EDITFRANCHISE,
        payload: res.data,
      });
    },
    err => {
      dispatch({
        type: EDITFRANCHISE,
        payload: {},
      });
    },
  );
};

export const fetchAdminFranchiseListings = (pageNumber = 1) => dispatch => {
  dispatch({ type: FETCH_FRANCHISE_LISTINGS_STARTED });
  franchiseService.getAdminFranchiseListings(pageNumber).then(
    res => {
      dispatch({
        type: FETCH_ADMIN_FRANCHISE_LISTINGS,
        payload: res.data,
      });
    },
    err => {
      dispatch({
        type: FETCH_ADMIN_FRANCHISE_LISTINGS,
        payload: { data: [] },
      });
    },
  );
};

export const searchAdminFranchiseListings = (
  startDate,
  endDate,
  searchQuery,
  status,
  byId,
  pageNumber = 1,
) => async dispatch => {
  dispatch({ type: FETCH_FRANCHISE_LISTINGS_STARTED });
  await franchiseService
    .searchAdminFranchiseListings(
      startDate,
      endDate,
      searchQuery,
      status,
      byId,
      pageNumber,
    )
    .then(
      res => {
        dispatch({
          type: FETCH_ADMIN_FRANCHISE_LISTINGS,
          payload: res.data,
        });
      },
      err => {
        dispatch({
          type: FETCH_ADMIN_FRANCHISE_LISTINGS,
          payload: { data: [] },
        });
      },
    );
};

export const selectPlan = plan => dispatch => {
  dispatch({
    type: SELECT_PLAN,
    payload: plan,
  });
};

export const resetForm = () => dispatch => {
  dispatch({ type: RESETFORMS });
};
